import { render, staticRenderFns } from "./Configuracao.vue?vue&type=template&id=d678bc6e&scoped=true&"
import script from "./Configuracao.vue?vue&type=script&lang=js&"
export * from "./Configuracao.vue?vue&type=script&lang=js&"
import style0 from "./Configuracao.vue?vue&type=style&index=0&id=d678bc6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d678bc6e",
  null
  
)

export default component.exports